export const fixVal = (val, def) => {
    if (val === null || val === undefined || val === '' || Number.isNaN(Number(val))) {
        val = def;
    } else {
        val = Number(val);
    }
    return val;
}
export const normalizeTickets = (list = []) =>
    list.map(t => {
        // jeśli brak|null|NaN|pusty string => ustaw 23
        let vat = fixVal(t?.vatPercentage, 23);
        let maxPerOrder = fixVal(t?.maxTicketsPerOrder, 10);
        let price = fixVal(t?.price, 0);
        let availableQuantity = fixVal(t?.availableQuantity, 0);

        return {
            ...t,
            vatPercentage: vat,
            maxTicketsPerOrder: maxPerOrder,
            price: price,
            availableQuantity: availableQuantity
        };
    });
